import { Injectable } from '@angular/core';
import Dexie from 'dexie';
import { Observable, from, BehaviorSubject } from 'rxjs';

export interface Report {
  id?: number;
  reportType: string;
  status: string;
  report: string;
  createDate: string;
  updateDate: string;
  isSynchronized: boolean;
}

export interface Setting {
  id?: number;
  username: string;
  password: string;
  savePhotos: string,
  environment: string;
  lastloginDate: Date;
}

@Injectable({
  providedIn: 'root'
})
export class IndexedDBService extends Dexie {
  reports: Dexie.Table<Report, number>;
  settings: Dexie.Table<Setting, number>;

  constructor() {
    super('rdsap994');
    this.version(1).stores({
      reports: '++id, reportType, status, report, createDate, updateDate, isSynchronized',
      settings: '++id, username, password, savePhotos, environment, lastloginDate'
    });
    this.reports = this.table('reports');
    this.settings = this.table('settings');
  }

  addReport(report: Report): Observable<number> {
    return from(this.reports.add(report));
  }

  getReport(id: number): Observable<Report> {
    return from(this.reports.get(id));
  }

  getAllReports(): Observable<Report[]> {
    return from(this.reports.toArray());
  }

  updateReport(id: number, updatedReport: Partial<Report>): Observable<number> {
    return from(this.reports.update(id, updatedReport));
  }
  
  deleteReport(id: number): Observable<void> {
    return from(this.reports.delete(id));
  }

  addSetting(setting: Setting): Observable<number> {
    return from(this.settings.add(setting));
  }

  getSettingByUsername(username: string): Observable<Setting | undefined> { 
    return from(this.settings.where('username').equalsIgnoreCase(username).first()); 
  }

  getRecentSetting(): Observable<Setting> {
    return from(this.settings.orderBy('lastloginDate').reverse().first());
  }

  updateSetting(id: number, updatedSetting: Partial<Setting>): Observable<number> {
    return from(this.settings.update(id, updatedSetting));
  }
}
